import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { EmployeeBenefitSettings } from '@pxtra-client-lib-legacy/gen';
import { FC, PropsWithChildren } from 'react';
import Util from '../../../../../misc/util';
import { RoundedPaper } from '../../../atomic';

export interface Benefit {
  key: keyof EmployeeBenefitSettings;
  usedBudget: number;
}

export interface Props {
  icon?: JSX.Element;
  title?: string;
  titleComponent?: string | JSX.Element;
  subTitle?: string;
  footerText?: string;
  onFooterClicked?: () => void;
  sx?: SxProps<Theme>;
}

export const CardWidget: FC<PropsWithChildren<Props>> = ({
  icon,
  title,
  titleComponent,
  subTitle,
  footerText,
  onFooterClicked,
  sx,
  children
}) => {
  const showHead = icon || title || titleComponent || subTitle;
  return (
    <RoundedPaper
      sx={Util.merge(
        {
          padding: `24px 24px ${footerText ? '50px' : '24px'} 24px`,
          position: 'relative'
        },
        sx
      )}
    >
      {showHead && (
        <Box sx={{ marginBottom: '24px', display: 'flex' }}>
          {icon && icon}
          <Box
            sx={{
              lineHeight: '28px',
              marginLeft: icon ? '1rem' : 0,
              marginY: 'auto'
            }}
          >
            <Box className="flex flex-row ">
              {title && <Typography variant="h3">{title}</Typography>}
              {titleComponent && (
                <Typography className="float-start text-grey-500 font-medium pl-3 text-lg">
                  {titleComponent}
                </Typography>
              )}
            </Box>

            <Box sx={{ clear: 'both' }} />
            {subTitle && (
              <Typography variant="body2" paddingTop="4px">
                {subTitle}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      {children}
      {footerText && (
        <Button
          sx={{
            paddingY: '16px',
            paddingRight: '24px',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'inherit',
            display: 'block'
          }}
          onClick={onFooterClicked}
        >
          <Typography
            sx={{
              textAlign: 'center',
              color: 'heaven.main',
              fontSize: '14px',
              lineHeight: '18px'
            }}
          >
            {footerText}
          </Typography>
        </Button>
      )}
    </RoundedPaper>
  );
};
